package de.ohhhmhhh.frontend.admin.ui.screens.team

data class TeamEditItem(
    val imageUrl: String?,
    val name: String?,
    val text: String?,
    val email: String?
)